const WECHAT_JSAPI_DEBUG_PARAM = 'jsapiDebug';

const isWechatJsapiDebugEnabled = (): boolean => {
  return new URLSearchParams(window.location.search).get(WECHAT_JSAPI_DEBUG_PARAM) === '1';
};

/**
 * 仅在 URL 携带 jsapiDebug=1 时展示手机端调试信息。
 * 禁止传入 OpenID、签名、完整 OAuth code、完整支付参数和服务端原始错误信息。
 */
const debugWechatJsapi = (message: string) => {
  if (!isWechatJsapiDebugEnabled()) return;
  // eslint-disable-next-line no-alert
  window.alert(`[微信 JSAPI 调试]\n${message}`);
};

const getWechatDebugError = (error: unknown): string => {
  const requestError = error as { code?: unknown; message?: unknown; status?: unknown };
  const details: string[] = [];

  if (requestError.code !== undefined) details.push(`code=${String(requestError.code)}`);
  if (requestError.status !== undefined) details.push(`status=${String(requestError.status)}`);
  if (requestError.message !== undefined) {
    details.push(`messageType=${typeof requestError.message}`);
    details.push(`messageLength=${String(requestError.message).length}`);
  }

  return details.length > 0 ? details.join('，') : '未知错误';
};

export { debugWechatJsapi, getWechatDebugError, isWechatJsapiDebugEnabled };
